import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from '../selectors/projectsSelectors';
import { getProjectFeatureStatusIndicatorItems } from '../services/getProjectFeatureStatusIndicatorsItem.service';

export const loadProjectFeatureStatusIndicatorItems = createAsyncThunk(
  'projects/loadProjectFeatureStatusIndicatorItems',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const projectActivityData = await getProjectFeatureStatusIndicatorItems(
      selectedProjectId
    );

    return projectActivityData;
  }
);
